<template>
  <banners :narrow="true">
    <div class="h-screen bg-lighter-gray px-4">
      <div
        v-if="has_incomplete_eld"
        class="m-auto pt-6 sm:min-w-[500px] md:w-[500px]"
      >
        <LoadsConnectEld @handle-load-search="handleLetsGo"></LoadsConnectEld>
      </div>

      <div
        v-else
        class="m-auto max-w-[500px] md:pt-8"
      >
        <div class="flex">
          <DashboardLoadSearch></DashboardLoadSearch>
        </div>

        <div
          v-if="recent_load_searches?.length > 0"
          class="my-8 flex flex-col gap-2"
        >
          <h4 class="text-left text-xl text-dark-blue">Your Recent Searches</h4>

          <div
            v-for="(search, searchIndex) in recent_load_searches"
            :key="searchIndex"
            class="border-gray flex w-full cursor-pointer justify-between rounded-lg border bg-white px-4 py-2 shadow-md"
            @click="handleRecentSearchRedirect(search)"
          >
            <div class="flex flex-1 items-center gap-2">
              <img
                class="h-4 w-4"
                src="@/assets/origin-marker.svg"
                alt="origin icon"
              />
              {{ search.origin_search_display_name || '-' }}
            </div>
            <div class="flex flex-1 items-center gap-2">
              <img
                class="h-5 w-5"
                src="@/assets/loads/destination-marker.svg"
                alt="destination icon"
              />
              {{ search.destination_search_display_name || '-' }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </banners>
</template>

<script>
import Banners from '@/components/Banners.vue';
import DashboardLoadSearch from '@/components/loads/DashboardLoadSearch.vue';
import LoadsConnectEld from '@/components/loads/LoadsConnectEld.vue';
import { createFilterQuery } from '@/utils/loadFilters';

export default {
  name: 'Loads Exchange',
  components: {
    Banners,
    DashboardLoadSearch,
    LoadsConnectEld,
  },
  data() {
    return {
      has_incomplete_eld: false,
    };
  },
  async created() {
    await this.$store.dispatch('loads/getLaneSearchHistory');
  },
  computed: {
    recent_load_searches() {
      return this.$store.state.loads?.lane_search_history
        ?.filter((el) => el.origin_search_display_name)
        ?.slice()
        ?.reverse()
        ?.slice(0, 4);
    },
  },
  methods: {
    handleLetsGo() {
      this.has_incomplete_eld = false;
    },
    async handleRecentSearchRedirect(search) {
      const searchObject = {
        ...search,
        origin: search?.origin_search_display_name,
        destination: search?.destination_search_display_name,
        selectedOrigin: search?.origin_area?.code,
        selectedDestination: search?.destination_area?.code,
      };
      await this.$store.commit('loads/setLoads', []);
      await this.$store.commit('loads/setLoadSearchFilters', searchObject);

      const params = createFilterQuery(
        search,
        this.$router.currentRoute.value.query
      );

      await this.$router.push({
        name: 'Load Board',
        query: params,
      });
    },
  },
};
</script>
